// extracted by mini-css-extract-plugin
export default {"segment":"SegmentedControl_segment__mZ5qD","on":"SegmentedControl_on__bPm7n"};